import { expValEquals } from '@confluence/feature-experiments';
import { cfetch } from '@confluence/network';

import { MarkdownImportError } from './MarkdownImportService.ts';

type CreateMarkdownFolderInput = {
	spaceId: string;
	title: string;
	signal: AbortSignal;
};

type V2FolderResponse = {
	id?: string;
};

export const createMarkdownFolder = async ({
	spaceId,
	title,
	signal,
}: CreateMarkdownFolderInput): Promise<string> => {
	if (signal.aborted) {
		throw new MarkdownImportError('aborted');
	}

	if (!/^\d+$/.test(spaceId)) {
		throw new MarkdownImportError('invalid_destination');
	}

	if (!expValEquals('twcg_2627_markdown_file_import_into_confluence', 'isEnabled', true)) {
		throw new MarkdownImportError('experiment_disabled');
	}

	const response = await cfetch('/wiki/api/v2/folders', {
		method: 'POST',
		credentials: 'include',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({ spaceId, title }),
		signal,
	});
	const folder = (await response.json()) as V2FolderResponse;

	if (!folder.id) {
		throw new Error('The create folder response did not contain an ID');
	}

	return folder.id;
};
